var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" This is your start page. You can customize where it takes you at "),_c('router-link',{attrs:{"to":{name: 'employee.details', params: {id: _vm.$store.getters.userId}}}},[_vm._v("your account page")]),_vm._v(". ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }